import { Box, useTheme } from '@mui/material';

import { MegaphoneLoudIcon } from '../icons';

export const NewsCardImageDefault = () => {
  const theme = useTheme();
  return (
    <Box
      role="presentation"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.grey[100],
        aspectRatio: '3/2',
        width: '100%',
        height: 'auto',
      }}
    >
      <Box sx={{ maxWidth: 'fit-content' }}>
        <MegaphoneLoudIcon stroke={theme.palette.primary.main} />
      </Box>
    </Box>
  );
};
